import React from 'react';
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import headerLogo from "../medias/header-logo.png";
import MoblieHeader from './MoblieHeader';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isResourcesOpen, setIsResourcesOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    
    useEffect(() => {
        let lastScrollTop = 0;
        const handleScroll = () => {
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            setIsScrolled(scrollTop > lastScrollTop);
            lastScrollTop = scrollTop;
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleLogoClick = (e) => {
        // If we're on the home page, scroll to top instead of navigating
        if (location.pathname === '/') {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        // If we're on another page, let the Link handle navigation to home
    };

    const handleHashNavigation = (hash) => {
        if (location.pathname === '/') {
            // We're already on home page, just scroll to the section
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        } else {
            // We're on a different page, navigate to home first, then scroll
            navigate('/');
            // Use setTimeout to ensure the page has loaded before scrolling
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }, 100);
        }
    };

    return (
        <motion.div
            style={{boxShadow: isScrolled ? '0px 2px 5px rgba(0, 0, 0, 0.2)' : 'none'}}
            className={`sticky top-0 left-0 right-0 z-50 bg-[#3B79B3] h-[66px]`}
        >
            <div className="flex justify-between items-center max-w-[1120px] mx-auto pt-[12px] px-[24px]">
                <Link to="/" onClick={handleLogoClick}>
                    <img className='cursor-pointer' src={headerLogo} alt="" style={{height: '40px'}}/>
                </Link>
                <div className='md:flex items-center gap-[24px] text-white hidden'>
                    <button onClick={() => handleHashNavigation('#demo')}><p className='text-[14px] font-semibold cursor-pointer header-link'>Demo</p></button>
                    <button onClick={() => handleHashNavigation('#how-it-works')}><p className='text-[14px] font-semibold cursor-pointer header-link leading-[16px]'>How it Works</p></button>
                    <button onClick={() => handleHashNavigation('#features')}><p className='text-[14px] font-semibold cursor-pointer header-link'>Features</p></button>
                    <button onClick={() => handleHashNavigation('#pricing')}><p className='text-[14px] font-semibold cursor-pointer header-link'>Pricing</p></button>
                    
                    {/* Resources Dropdown */}
                    <div className="relative group">
                        <button 
                            className="text-[14px] font-semibold cursor-pointer header-link flex items-center"
                            onMouseEnter={() => setIsResourcesOpen(true)}
                            onMouseLeave={() => setIsResourcesOpen(false)}
                        >
                            Resources
                            <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        <div 
                            className={`absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg transition-all duration-200 overflow-hidden ${
                                isResourcesOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
                            }`}
                            onMouseEnter={() => setIsResourcesOpen(true)}
                            onMouseLeave={() => setIsResourcesOpen(false)}
                        >
                            <Link 
                                to="/blog" 
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-150"
                            >
                                Blog
                            </Link>
                            <a 
                                style={{display: 'none'}}
                                href="https://discord.gg/customsync" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-150"
                            >
                                Discord Group
                            </a>
                        </div>
                    </div>
                    
                    <a href="https://customsync.app/login?signup=true"><p className='text-[14px] font-semibold cursor-pointer header-link text-center leading-[16px]'>Sign up</p></a>
                    <a href="https://customsync.app/login">
                        <div className="cursor-pointer text-white text-nowrap bg-[#F29E13] max-w-[175px] px-[16px] py-[8px] rounded-lg font-bold orange-button">
                            Login
                        </div>
                    </a>
                </div>
                <div className='md:hidden block'>
                    <MoblieHeader />
                </div>
            </div>
        </motion.div>
    );
};

export default Header;